import { memo, useMemo, useCallback, useEffect, useState, createRef } from 'react';
import { View, StyleSheet, Text, Image, ScrollView } from 'react-native';
import { I18n, Utils, Navigation, ActionButton } from '../../components';
import { THEME, __WEB__, COLOR, FONT } from '../../../constants/styles';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getCurrentEmployer } from '../../../selectors/entities';
import {
  saveEmployerSetupData,
  deleteEmployerSetupData,
  resetStatus,
} from '../../employer/actions';
import * as ASSETS from '../../../constants/assets';

let submitTimeout = null;

const Row = memo(function (props) {
  function deleteData() {
    const data = {
      ...props.item,
      pager: null,
      landline: null,
      shifts: [],
    };
    delete data['employer_clinical_location_medical_service_id'];
    delete data['count'];
    props.saveEmployerSetupData(props.employer.employerId, 'clinicalLocationMedicalService', data);
  }

  function handleEditPress() {
    props.onEdit();
    Navigation.showModal({
      screen: 'ClinicalLocationMedicalServiceForm',
      title: `${props.selectedLocationName} ${props.item.name}`,
      passProps: {
        item: props.item,
      },
      options: {
        width: 550,
      },
    });
  }
  function handleDeletePress() {
    const confirmationOpts = {
      title: 'Delete this item?',
      confirm: 'Yes, Delete',
      onConfirmed: () => {
        deleteData();
      },
    };
    props.onConfirmationOpts(confirmationOpts);
  }

  function renderButtons() {
    return (
      <View style={[THEME.basicRow, THEME.rowButtons, { justifyContent: 'center' }]}>
        <ActionButton
          source={ASSETS.pager}
          disabled={!props.canEdit}
          onPress={handleEditPress}
          extraStyle={{ width: 24, height: 18 }}
        />
        <ActionButton
          source={ASSETS.reject}
          disabled={!props.canEdit}
          onPress={handleDeletePress}
        />
      </View>
    );
  }
  return (
    <View
      style={[
        THEME.basicRow,
        { backgroundColor: props.i % 2 === 0 ? COLOR.contrast : COLOR.altContrast },
      ]}
    >
      <View style={[THEME.rowColumn, { flexGrow: 1, width: 120 }]}>
        <Text style={THEME.rowText}>{props.item?.name}</Text>
      </View>
      <View style={[THEME.rowColumn, { flexGrow: 1, width: 100 }]}>
        <Text style={THEME.rowText}>{Utils.formatPhone(props.item?.pager)}</Text>
      </View>

      <View style={[THEME.rowColumn, { flexGrow: 1, width: 110 }]}>
        <Text style={THEME.rowText}>{Utils.formatPhone(props.item?.landline)}</Text>
      </View>
      <View style={[THEME.rowColumn, { width: 40 }]}>
        <Text style={THEME.rowText}>{props.item?.count}</Text>
      </View>
      <View style={[{ width: 100 }]}>{renderButtons()}</View>
    </View>
  );
});

export default memo(
  connect(
    function (state, ownProps) {
      const employer = getCurrentEmployer(state);
      return {
        employer,
        items: (state.screens.employer.setupData?.clinicalLocationMedicalService || [])
          .filter((m) => m.employer_clinical_location_id === ownProps.selectedLocationId)
          .map((m) => {
            return {
              ...m,
              name: (state.screens.employer.setupData?.medicalServices || []).find(
                (ms) => ms.employer_medical_service_id === m.employer_medical_service_id
              )?.name,
            };
          })
          .slice()
          .sort(function (a, b) {
            return a.name < b.name ? -1 : 1;
          }),
      };
    },
    function (dispatch) {
      return {
        actions: bindActionCreators(
          { saveEmployerSetupData, deleteEmployerSetupData, resetStatus },
          dispatch
        ),
      };
    }
  )(function (props) {
    function handleEditPress() {
      props.actions.resetStatus();
    }
    function renderRow(item, i) {
      return (
        <Row
          i={i}
          item={item}
          key={item.name}
          employer={props.employer}
          saveEmployerSetupData={props.actions.saveEmployerSetupData}
          onConfirmationOpts={props.onConfirmationOpts}
          selectedLocationName={props.selectedLocationName}
          onEdit={handleEditPress}
          canEdit={props.canEdit}
        />
      );
    }
    return (
      <View style={styles.container}>
        <ScrollView
          keyboardShouldPersistTaps="never"
          alwaysBounceVertical={false}
          keyboardDismissMode="on-drag"
          stickyHeaderIndices={[0]}
        >
          <View>
            <View style={THEME.sectionHeader}>
              <View style={[styles.sectionHeaderColumn, { flexGrow: 1, width: 120 }]}>
                <Text style={THEME.sectionHeaderText}>NAME</Text>
              </View>
              <View style={[styles.sectionHeaderColumn, { flexGrow: 1, width: 100 }]}>
                <Text style={THEME.sectionHeaderText}>PAGER</Text>
              </View>
              <View style={[styles.sectionHeaderColumn, { flexGrow: 1, width: 110 }]}>
                <Text style={THEME.sectionHeaderText}>LANDLINE</Text>
              </View>
              <View style={[styles.sectionHeaderColumn, { width: 40 }]}>
                <Image
                  style={{ width: 13, height: 14 }}
                  source={require('../../../../resources/staff-icon-small.png')}
                />
              </View>
              <View style={[styles.sectionHeaderColumn, { width: 100, borderRightWidth: 0 }]}>
                <Text style={THEME.sectionHeaderText}>ACTIONS</Text>
              </View>
            </View>
            <View>{props.items?.map(renderRow)}</View>
          </View>
        </ScrollView>
      </View>
    );
  })
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  sectionHeaderColumn: {
    ...THEME.sectionHeaderColumn,
    paddingVertical: 10,
  },
});
